module.exports = __webpack_public_path__ + "static/media/ssv-docs.46e63b0a.png";